// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#matrix {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.profileAvatar.ui.image {
  width: 250px;
  padding: 3px;
  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12),
    0px 2px 10px 0px rgba(34, 36, 38, 0.15);
}

.mainContainer {
  margin-top: 100px;
  margin-bottom: 100px;
}

.technologies {
  margin: 70px;
  font-size: 5rem;
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ;2CACyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB","sourcesContent":["#matrix {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.profileAvatar.ui.image {\r\n  width: 250px;\r\n  padding: 3px;\r\n  box-shadow: 0px 2px 4px 0px rgba(34, 36, 38, 0.12),\r\n    0px 2px 10px 0px rgba(34, 36, 38, 0.15);\r\n}\r\n\r\n.mainContainer {\r\n  margin-top: 100px;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.technologies {\r\n  margin: 70px;\r\n  font-size: 5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
